<script lang="ts">
  export let href: string;
  export let text: string = "Learn More";
  export let useLink:boolean = true;
  export let green: boolean;
  export let onClick: (() => void) | null;
  const url=`${useLink ? '/#' : ''}${href}`
</script>

<a href={url} on:click={onClick}>
  <button class="btn learn-more {green ? 'green-border' : 'grey-border'}">
    <div class="btn-flex">
      <span class="content" class:green>{text} →</span>
    </div>
  </button>
</a>

<style>
  .btn-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .learn-more {
    box-sizing: border-box;
    border-radius: 5px;
    width: 191px;
    height: 58px;
  }

  .green-border {
    border: 2px solid rgba(58, 153, 73, 0.2);
  }

  .grey-border {
    border: 1.5px solid rgba(0, 0, 0, 0.2);
  }

  .content {
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
  }

  .green {
    color: #3a9948;
  }
</style>
